module.exports = __webpack_public_path__ + "static/img/contentLeftImg2.e5e05e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentLeftImg2.png
// module id = N0BP
// module chunks = 2